const updateProductPlacementDetails = ({ product, cls }) => {
  try {
    // get the class data
    // if the class chosen is 114 (old AFNP, make it 129 FNC)
    if (product.classId === 114) {
      product.classId = 129
    }

    if (!product.title) {
      product.title = cls.title
    }

    if (!product.image && cls.image?.crops) {
      const { image } = cls
      const orgImage = image.crops.find(({ dimensions }) => dimensions === "original") || image.path
      // find the largest cropped image by multiplying the dimensions
      const [largestImage] = image.crops
        .filter(({ dimensions }) => dimensions !== "original")
        .sort((a, b) => {
          const { width: aWidth, height: aHeight } = a
          const { width: bWidth, height: bHeight } = b
          return bWidth * bHeight - aWidth * aHeight
        })
      product.image = {
        path: largestImage?.path || orgImage?.path,
        crops: image.crops,
      }
    }

    if (!product.url) {
      product.url = cls.url
    }

    if (!product.description) {
      product.description = cls.instructorByline || cls.subtitle || cls.description
    }

    // use the class ID to create the trackProduct
    product.trackProduct = `class-${cls.id}`

    return product
  } catch (err) {
    console.log(err)
  }
}

const SPECIAL_CLASS_PATHS = [
  "functional-nutrition-training",
  "health-coach-certification",
  "health-coach-certification-2",
  "life-coaching-certification",
]

const getPathFromUrl = (url) => url?.match(/\/(classes|coaching)\/([^/?]+)/)?.[2]

const findMatchingClass = (urlPath, classes) =>
  classes.find((cls) => {
    const classPath = getPathFromUrl(cls.url)
    return urlPath && classPath && urlPath === classPath
  })

const swapClassData = ({ item, type, classes }) => {
  const { classId, url } = item

  if (!classId && url?.match(/mindbodygreen\.com\/(classes|coaching)\//)) {
    const urlPath = getPathFromUrl(url)
    const matchingClass = findMatchingClass(urlPath, classes)

    if (matchingClass?.availableForPurchase) {
      return updateProductPlacementDetails({
        product: item,
        cls: matchingClass,
      })
    }

    return SPECIAL_CLASS_PATHS.includes(urlPath) ? item : null
  }

  // Original class ID handling
  const cls = classes.find((p) => Number(p.classId) === Number(classId) && p.availableForPurchase)

  if (!cls) {
    return null
  }

  if (type === "product") {
    return updateProductPlacementDetails({
      product: item,
      cls,
    })
  }

  if (type === "review") {
    // not implemented
  }

  if (type === "shop") {
    // not implemented
  }

  return item
}

export default swapClassData
